import React from 'react'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'

import { WithAnalytics } from 'analytics/components'
import DEFAULTS from 'core/data-model/constants/defaults'
import MESSAGES from 'core/data-model/constants/messages'
import { renderBIAge } from 'core/service/insured/age'
import { isEmpty, isNil, isNotNil } from 'core/service/lib/type-check'
import { getAge, getGender, getSelectedOccupation } from 'quick-quote/insured-information/selectors'
import {
  getSelectedDisplayProductName,
  getSelectedDisplayProductCode,
  getSelectedDisplayBasicPlanName,
} from 'quick-quote/product-selection/selectors'
import { isReviseQQFlow } from 'quick-quote/selectors'

import createNavigationButtonConfigurations from './navigations/nav-buttons'
import { clickHomeButton } from 'quick-quote/actions'

const translations = {
  gender: {
    M: MESSAGES.MALE,
    F: MESSAGES.FEMALE,
  },
  unit: {
    year: MESSAGES.TIME_UNIT_YEAR,
    month: MESSAGES.TIME_UNIT_MONTH,
    day: MESSAGES.TIME_UNIT_DAY,
  },
}

export const PersonalInformationBreadCrumb = ({
  productName,
  productCode,
  basicPlanName,
  gender,
  age,
  occupation,
  className,
  isReviseQQ,
}) => {
  const getOccupationLabel = (occupation) => {
    if (occupation && occupation.th && occupation.th.occupationName && occupation.th.natureOfDuty) {
      return `${occupation.th.occupationName}, ${occupation.th.natureOfDuty}`
    } else {
      return '-'
    }
  }

  let infoWholeLife = [
    DEFAULTS.LIST_PRODUCT_CODE_USE_BASIC_PLANNAME_IN_BREADCRUMB.includes(productCode) ? basicPlanName : productName,
    translations.gender[gender],
    age.value ? renderBIAge(age, isReviseQQ) : '-',
    getOccupationLabel(occupation),
  ]
  let infoInvestment = [productName, translations.gender[gender], age.value ? renderBIAge(age, isReviseQQ) : '-']
  const personalInformation = productName === 'iWealthy' ? infoInvestment : infoWholeLife

  return (
    <div className={`personal-information-breadcrumb ${className ? className : ''}`}>
      <p>{personalInformation.filter((value) => isNotNil(value) && !isEmpty(value)).join(' / ')}</p>
    </div>
  )
}

const mapInsuredInformationBreadcrumbStateToProps = (state) => ({
  productName: getSelectedDisplayProductName(state),
  productCode: getSelectedDisplayProductCode(state),
  basicPlanName: getSelectedDisplayBasicPlanName(state),
  age: getAge(state),
  occupation: getSelectedOccupation(state),
  gender: getGender(state),
  isReviseQQ: isReviseQQFlow(state),
})

export const InsuredInformationBreadcrumb = connect(mapInsuredInformationBreadcrumbStateToProps)(
  PersonalInformationBreadCrumb
)

const _BackToHome = connect(
  (state) => ({}),
  (dispatch) => ({
    backToHome: bindActionCreators(clickHomeButton, dispatch),
  })
)((props) => (
  <Button onClick={props.backToHome} type="button" color="primary" outline={true}>
    กลับ
  </Button>
))

const _BackButton = ({ backButton }) => {
  if (isEmpty(backButton)) {
    return null
  }
  if (backButton && backButton.toHome) {
    return <_BackToHome />
  }
  if (backButton && isNil(backButton.to)) {
    const color = 'primary'
    return (
      <Button onClick={() => window.history.back()} type="button" color={color} outline={true}>
        กลับ
      </Button>
    )
  }
  if (backButton) {
    return (
      <Link to={backButton.to} className="back">
        <Button type="button" color="primary" outline={true}>
          กลับ
        </Button>
      </Link>
    )
  } else {
    return null
  }
}

const _NextButton = ({ nextButton }) => {
  if (isEmpty(nextButton)) {
    return null
  }

  if (nextButton.type === 'component') {
    return React.cloneElement(nextButton.component, { disabled: nextButton.disabled })
  }

  if (nextButton.disabled) {
    return <Button color="disabled">{nextButton.text}</Button>
  }

  return (
    <WithAnalytics eventType={nextButton.analyticsEventType} expectedEventType="BIEvent">
      <Link to={nextButton.to} className="next">
        <Button color="primary" onClick={nextButton.onClick}>
          {nextButton.text}
        </Button>
      </Link>
    </WithAnalytics>
  )
}

export const _NavigationButton = (props) => {
  const { navigationButtonConfigurations } = props
  const location = useLocation()
  const navConfig = navigationButtonConfigurations.find(
    ({ path, excludePath }) =>
      location.pathname.startsWith(path) && (excludePath ? !location.pathname.includes(excludePath) : true)
  )

  if (navConfig) {
    const {
      backButton,
      nextButton,
      extraButton: ExtraButton,
      additionalSectionFooter: AdditionalSectionFooter,
    } = navConfig.props
    return (
      <div id="nav-bottom" className="nav-bottom">
        <div className="nav-group">
          {AdditionalSectionFooter && <AdditionalSectionFooter />}
          <div className="left">
            <_BackButton backButton={backButton} />
          </div>
          {ExtraButton && <ExtraButton />}
          <_NextButton nextButton={isNotNil(nextButton) ? nextButton : props.nextButton} />
        </div>
      </div>
    )
  } else {
    return null
  }
}

const mapStateToProps = (state) => {
  return {
    navigationButtonConfigurations: createNavigationButtonConfigurations(state),
  }
}

export const NavigationButton = connect(mapStateToProps)(_NavigationButton)
